// // src/components/GTMPageView.jsx
// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// export default function GTMPageView() {
//   const location = useLocation();

//   useEffect(() => {
//     const getPageType = (path) => {
//       if (path === '/') return 'homepage';
//       if (path === '/Event') return 'event';
//       if (path === '/about') return 'about';
//       if (path === '/blog') return 'blog';
//       if (path.startsWith('/blog/')) return 'blog_post';
//       return 'other';
//     };

//     const getStoredUTM = () => {
//       const stored = sessionStorage.getItem('utm_params');
//       if (stored) {
//         return JSON.parse(stored);
//       }
//       return {
//         utm_source: '',
//         utm_medium: '',
//         utm_campaign: '',
//         utm_term: '',
//         utm_content: '',
//         gclid: '',
//         fbclid: '',
//         ttclid: ''
//       };
//     };

//     const utmData = getStoredUTM();

//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({
//       'event': 'page_view',
//       'page_type': getPageType(location.pathname),
//       'page_path': location.pathname,
//       'page_url': window.location.href,
//       'page_title': document.title,
//       'page_referrer': document.referrer,
//       'utm_source': utmData.utm_source,
//       'utm_medium': utmData.utm_medium,
//       'utm_campaign': utmData.utm_campaign,
//       'utm_term': utmData.utm_term,
//       'utm_content': utmData.utm_content,
//       'gclid': utmData.gclid,
//       'fbclid': utmData.fbclid,
//       'ttclid': utmData.ttclid
//     });
//   }, [location]); 

//   return null; 
// }

// src/components/GTMPageView.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function GTMPageView() {
  const location = useLocation();

  useEffect(() => {
    // Only track screen_view_home for homepage
    // Other pages don't have defined screen events in the Excel
    if (location.pathname === '/') {
      const getStoredUTM = () => {
        const stored = sessionStorage.getItem('utm_params');
        if (stored) {
          return JSON.parse(stored);
        }
        return {
          utm_source: '',
          utm_medium: '',
          utm_campaign: '',
          utm_term: '',
          utm_content: '',
          gclid: '',
          fbclid: '',
          ttclid: ''
        };
      };

      const utmData = getStoredUTM();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'screen_view_home',
        'page_title': document.title,
        'referrer_source': document.referrer,
        'utm_source': utmData.utm_source,
        'utm_medium': utmData.utm_medium,
        'utm_campaign': utmData.utm_campaign,
        'utm_term': utmData.utm_term,
        'utm_content': utmData.utm_content,
        'gclid': utmData.gclid,
        'fbclid': utmData.fbclid,
        'ttclid': utmData.ttclid
      });
    }
  }, [location]);

  return null;
}